<!-- 物理因素接触限值手传震动 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">工作场所手传振动职业接触限值</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="touchDuration" label="接触时间">
      </el-table-column>
      <el-table-column align="center" prop="acceleration" label="等能量频率计权振动加速度（m/s2）">
      <template slot='header'>
        <span>等能量频率计权振动加速度（m/s</span>
        <sup>2</sup>
        <span>)</span>
      </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.findHandBorneVibration()
    },
    methods:{
      async findHandBorneVibration(){
        let res = await this.$axios.get(this.$serviceAPI.findHandBorneVibration)
        this.tableData = res.data.data
      }
    },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/handBorneVibration.vue